import { EMPTY_LET_PASS_ACCOUNT_MODEL } from "presentation/model/LetPassAccount/LetPassAccountModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: LetPassAccountProvider,
    useTracked: useLetPassAccountTracked
} = createContainer(() => useState(EMPTY_LET_PASS_ACCOUNT_MODEL), { concurrentMode: true });
export { LetPassAccountProvider, useLetPassAccountTracked };

